:host {
    display: flex;
    gap: 20px;
}

::slotted(a) {
    text-decoration: none;
    color: currentColor;
    width: 24px;
}
